import styled from 'styled-components';
import { colors, fontSizes } from '../../../defaultTheme';
const NOT_ALLOWED = 'not-allowed';
const TEXT = 'text';
export const Container = styled.div `
  width: ${({ width }) => width};
  color: ${({ hasError }) => (hasError ? colors.error : colors.mediumGrey)};
  text-align: left;
  height: ${({ width, sizeRatio, dynamicHeight }) => !dynamicHeight && `calc(${width} / ${sizeRatio})`};
  max-width: 100%;
  min-height: 100px;
`;
export const Input = styled.textarea `
  max-width: 100%;
  position: absolute;
  top: 25px;
  font-size: ${fontSizes.root}px;
  left: ${({ hasIcon }) => (hasIcon ? '0' : '16px')};
  width: calc(100% - 30px);
  height: calc(100% - 30px);
  border: none;
  background: none;
  cursor: ${({ disabled }) => (disabled ? NOT_ALLOWED : TEXT)};
  color: ${({ hasContent, disabled }) => hasContent && !disabled ? colors.black : 'inherit'};
  padding: 0;
  &:focus {
    outline: none;
    color: ${colors.black};
  }
  &:hover {
    border: none;
    outline: none;
  }
  font-family: Open Sans;
  resize: none;
`;
export const Label = styled.label `
  position: absolute;
  font-size: inherit;
  font-family: Open Sans;
  left: ${({ hasIcon }) => (hasIcon ? '0' : '16px')};
  top: 10px;
  transition-property: left, top, font-size;
  transition-duration: 0.2s;
  color: ${({ hasContent, hasError, isDisabled, theme }) => {
    if (hasError)
        return `${colors.error}`;
    if (hasContent && !isDisabled)
        return `${theme.field.label}`;
    return `${colors.mediumGrey}`;
}};
  cursor: ${({ isDisabled }) => (isDisabled ? NOT_ALLOWED : TEXT)};
  text-indent: 0;
  ${({ hasContent }) => hasContent
    ? `
        font-size: ${fontSizes.small}px;
        top: 3px;
      `
    : ''}
  ${Input}:focus ~ & {
    font-size: ${fontSizes.small}px;
    top: 3px;
  }
  ${Input}:-webkit-autofill ~ & {
    font-size: ${fontSizes.small}px;
    top: 3px;
  }
`;
export const InputWrapper = styled.div `
  color: ${({ hasError }) => (hasError ? colors.error : colors.mediumGrey)};
  width: 100%;
  height: 100%;
  min-height: 100px;
  position: relative;
  border-radius: 6px;
  box-shadow: 0 0 0
    ${({ isDisabled, hasError }) => {
    if (isDisabled)
        return `1px ${colors.grey}`;
    if (hasError)
        return `2px ${colors.error}`;
    return `1px ${colors.heavyGrey}`;
}};
  display: flex;
  align-items: center;
  &:hover {
    ${({ hasError, isDisabled }) => hasError || isDisabled
    ? ''
    : `box-shadow: 0 0 0 2px ${colors.heavyGrey};`}
  }
  cursor: ${({ isDisabled }) => (isDisabled ? NOT_ALLOWED : TEXT)};
  background-color: ${({ isDisabled }) => isDisabled ? colors.lightestGrey : colors.white};
  &:focus-within {
    box-shadow: 0 0 0 2px
      ${({ hasError, theme }) => (hasError ? colors.error : theme.field.focus)};
  }
`;
